import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import ChargeStationBingMapView2 from '../../components/ChargeStationBingMapView2';

ChargeStationMapScreen.propTypes = {};

function ChargeStationMapScreen(props) {
  return (
    <KT01BaseLayout isFullScreen={true}>
      <div className="container-fluid px-0">
        <ChargeStationBingMapView2 />
      </div>
    </KT01BaseLayout>
  );
}

export default ChargeStationMapScreen;
